/**
 * Accounting → Payroll payments (spec D13): paying a posted run is
 * payroll_run_pay.create, posting that payment is accounting_journal_post.create,
 * and reversing a posted run is payroll_run_reverse.create (ERP-99). Any one
 * key opens the screen; each button follows its own key. The API
 * authorises every call, so this only decides what the UI offers.
 */
export const PAYROLL_PAYMENTS_KEYS = [
  'payroll_run_pay.create',
  'accounting_journal_post.create',
  'payroll_run_reverse.create',
] as const

export function canOpenPayrollPayments(can: (permissionKey: string) => boolean): boolean {
  return PAYROLL_PAYMENTS_KEYS.some((key) => can(key))
}
